export default "__VITE_ASSET__C9tFcrBk__"